<template>
  <div>
    <div class="iframe-container">
      <iframe id="ib-iframe" :src="iframeURL"></iframe>
    </div>

    <template v-if="isSpinner">
      <Spinner></Spinner>
    </template>

    <template v-if="isModal">
      <Modal @close="handleCloseModal">
        <template v-slot:body>
        
        <vue-tabs>
        <v-tab title="Content">
          
         <div style="margin-top:10px;">
          <div>
            <p><b>{{content.info}}</b></p>
          </div><br/>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"/></svg>
            &nbsp;<a @click="handleCloseModal">Replace Insertion</a>
          </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
              </svg>
              &nbsp;<a @click="handleDeleteContent">Remove Insertion</a>
            </div>
         </div><br/>

          <h4>Dimensions</h4>
          <div style="display:flex">
            <div style="width:33%;">
                Display Width:
                <input id="imgwidth" style="width:100%;" :value="content.width" v-on:change="handleWidthInput"/>
            </div>
            <div style="width:33%;margin-left:3%;">
                Display Height:
                <input id="imgheight" style="width:100%;" :value="content.height" v-on:change="handleHeightInput"/>
            </div>
            <div style="width:33%;">
              <input style="width:33%;margin-top:23%;" type="checkbox" :checked="content.scale" v-on:click="handleScaleToFit($event)" />Scale to Fit
            </div>
          </div><br/>
          
          <div>
            Alt Text
            <input id="alttext" style="width:100%" :value="content.alt"/>
          </div> <br/>
          
          <h4>Content Border</h4>
          <div style="display:flex;">
            <input type="color" id="bordercolor" name="bordercolor" :value="content.bordercolor" v-on:change="handleBorderColor($event)">
            <input type="text" id="bordercolorinput" name="bordercolorinput" :value="content.bordercolor" style="margin-left:10px;">
            <select id="borderstyle" v-on:change="handleBorderStyle($event)" v-model="content.borderstyle" style="margin-left:10px;">
              <option v-for="(option,i) in options" :value="option.value" :key="i">
                {{ option.text }}
              </option>
            </select>
          </div><br/>

          <h4>Content Border Width</h4>
          <div>
            <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="btop" name="btop" class="borderInput" v-on:change="handleBorderWidth($event)" :value="content.borderwidtht" /></div>
            <div style="width:10%;height:40%;float:left;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="bleft" name="bleft" class="borderInput" v-on:change="handleBorderWidth($event)" :value="content.borderwidthl" /></div>
            <div style="width:10%;height:40%;float:right;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="bright" name="bright" class="borderInput" v-on:change="handleBorderWidth($event)" :value="content.borderwidthr" />
            </div>
            <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;margin-top:6%;">
                <input type="text" id="bbottom" name="bbottom" class="borderInput" v-on:change="handleBorderWidth($event)" :value="content.borderwidthb" /></div>
          </div> <br/>

          <h4>Content Padding</h4>
          <div>
            <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="ptop" name="ptop" class="borderInput" v-on:change="handleImagePadding($event)" :value="content.imagepaddingt" /></div>
            <div style="width:10%;height:40%;float:left;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="pleft" name="pleft" class="borderInput" v-on:change="handleImagePadding($event)" :value="content.imagepaddingl" /></div>
            <div style="width:10%;height:40%;float:right;background-color:#e7e7e7;text-align:center;">
                <input type="text" id="pright" name="pright" class="borderInput" v-on:change="handleImagePadding($event)" :value="content.imagepaddingr" /></div>
            <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;margin-top:6%;">
                <input type="text" id="pbottom" name="pbottom" class="borderInput" v-on:change="handleImagePadding($event)" :value="content.imagepaddingb" /></div>
          </div> <br/>

          <h4>Content Alignment</h4>
          <div>
            <button id="leftbtn" class="alignbtn" @click="handleAlignment" value="left">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-align-start" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M1.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/>
                  <path d="M3 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7z"/>
              </svg>      
            </button>
            <button id="centerbtn" class="alignbtn" @click="handleAlignment" value="center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-align-center" viewBox="0 0 16 16">
                <path d="M8 1a.5.5 0 0 1 .5.5V6h-1V1.5A.5.5 0 0 1 8 1zm0 14a.5.5 0 0 1-.5-.5V10h1v4.5a.5.5 0 0 1-.5.5zM2 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7z"/>
              </svg>
            </button>
            <button id="rightbtn" class="alignbtn" @click="handleAlignment" value="right">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-align-end" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/>
                <path d="M13 7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"/>
              </svg>
            </button>
          </div><br/>
          
          <div>
            <div>
              <h4>Add Link</h4>
              <span id="linkvalue" :value="content.linkvalue">{{content.linkvalue}}</span>
              <button id="link" @click="handleLink" style="display:block;">Add</button><br/>
            </div>
            <div id="removelinkblock" style="display:none;">
              <a @click="handleLink">Edit</a> &nbsp;&nbsp;
              <a @click="handleRemoveLink">Remove</a>
            </div>
          </div>

          </v-tab>
          <v-tab title="Block">
            <div style="margin-top:10px;">
              <h4>Background</h4>
              <div style="display:flex;">
                <input type="color" id="backcolor" name="backcolor" :value="content.containerbackgroundcolor" v-on:change="handlebackColor($event)">
                <input type="text" id="backcolorinput" name="backcolorinput" :value="content.containerbackgroundcolor" style="margin-left:10px;" v-on:change="handlebackColor($event)">
              </div><br/>

              <h4>Border</h4>
              <div style="display:flex;">
                <input type="color" id="bordercolor" name="bordercolor" :value="content.containerbordercolor" v-on:change="handleContainerBorderColor($event)">
                <input type="text" id="bordercolorinput" name="bordercolorinput" :value="content.containerbordercolor" style="margin-left:10px;" v-on:change="handleContainerBorderColor($event)">

                <select id="borderstyle" v-on:change="handleContainerBorderStyle($event)" v-model="content.containerborderstyle" style="margin-left:10px;">
                  <option v-for="(option,i) in options" :value="option.value" :key="i">
                    {{ option.text }}
                  </option>
                </select>
              </div><br/>

              <h4>Border Width</h4>
              <div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="bctop" name="bctop" class="borderInput" v-on:change="handleContainerBorderWidth($event)" :value="content.containerborderwidtht" /></div>
                <div style="width:10%;height:40%;float:left;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="bcleft" name="bcleft" class="borderInput" v-on:change="handleContainerBorderWidth($event)" :value="content.containerborderwidthl" /></div>
                <div style="width:10%;height:40%;float:right;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="bcright" name="bcright" class="borderInput" v-on:change="handleContainerBorderWidth($event)" :value="content.containerborderwidthr" />
                </div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;margin-top:6%;">
                  <input type="text" id="bcbottom" name="bcbottom" class="borderInput" v-on:change="handleContainerBorderWidth($event)" :value="content.containerborderwidthb" /></div>
              </div> <br/>
            
              <h4>Padding</h4>
              <div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="pctop" name="pctop" class="borderInput" v-on:change="handleContainerPadding($event)" :value="content.containerblockpaddingt" /></div>
                <div style="width:10%;height:40%;float:left;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="pcleft" name="pcleft" class="borderInput" v-on:change="handleContainerPadding($event)" :value="content.containerblockpaddingl" /></div>
                <div style="width:10%;height:40%;float:right;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="pcright" name="pcright" class="borderInput" v-on:change="handleContainerPadding($event)" :value="content.containerblockpaddingr" /></div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;margin-top:6%;">
                  <input type="text" id="pcbottom" name="pcbottom" class="borderInput" v-on:change="handleContainerPadding($event)" :value="content.containerblockpaddingb" /></div>
              </div> <br/>

              <h4>Margin</h4>
              <div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="mtop" name="mtop" class="borderInput" v-on:change="handleContainerMargin($event)" :value="content.containerblockmargint" /></div>
                <div style="width:10%;height:40%;float:left;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="mleft" name="mleft" class="borderInput" v-on:change="handleContainerMargin($event)" :value="content.containerblockmarginl" /></div>
                <div style="width:10%;height:40%;float:right;background-color:#e7e7e7;text-align:center;">
                  <input type="text" id="mright" name="mright" class="borderInput" v-on:change="handleContainerMargin($event)" :value="content.containerblockmarginr" /></div>
                <div style="width:100%;height:40%;background-color:#e7e7e7;text-align:center;margin-top:6%;">
                  <input type="text" id="mbottom" name="mbottom" class="borderInput" v-on:change="handleContainerMargin($event)" :value="content.containerblockmarginb" /></div>
              </div> 
            </div>
          </v-tab>
        </vue-tabs>
        </template>
        <template v-slot:footer>
          <button class="slds-button slds-button_neutral" @click="handleCloseModal">Close</button>
        </template>
      </Modal>
    </template>
    
    <template v-if="isError">
      <Prompt :message="errorMessage" :title="'Error'" :variant="'error'">
        <template v-slot:footer>
          <button class="slds-button slds-button_neutral" @click="hidePrompt">Got It</button>
        </template>
      </Prompt>
    </template>

    <div id="myModal" class="modal">
        <div class="modal-content">
            <div style="text-align:center;">
              <span aria-hidden="true" class="close" @click="handleCloseLinkModel">&times;</span>
              <p>Insert Link</p>
            </div>
          
          <div style="margin-top:9%; border-top:2px solid #d8dde6;">  
            <div style="margin-top:4%;">
              Link To 
              <select id="linkto" v-on:change="addLink($event)">
                <option value="website">Website(http://)</option>
                <option value="securewebsite">Secure Website(https://)</option>
                <option value="email">Email Address</option>
              </select>
            </div>
            <div id="linkfield" style="display:block;">
              Link URL <br/> 
              <input type="text" id="linkurl" style="width:73%;" placeholder="Enter URL" :value="content.linkurl" v-on:input="showSaveBtn" /> 
                <select id="profile1" style="width:20%;margin-left:2%;" v-on:change="handleProfile($event)">
                      <option selected="true" disabled="true">Profile Attribute</option>
                      <option value="%%emailaddr%%">Email Address</option>
                      <option value="%%FirstName%%">FirstName</option>
                  </select>
            </div>
            
            <div id="emailfields" style="display:none;">
              EmailAddress <br/><input type="text" id="emailid" style="width:73%;" placeholder="Enter Email" :value="content.emailaddress" v-on:input="showSaveBtn" />
              <select id="profile2" style="width:20%;margin-left:2%;" v-on:change="handleProfile($event)">
                      <option selected="true" disabled="true">Profile Attribute</option>
                      <option value="%%emailaddr%%">Email Address</option>
                      <option value="%%FirstName%%">FirstName</option>
              </select><br/>
              Subject<br/> <input type="text" id="sub" style="width:73%;" placeholder="Enter Subject" :value="content.subject" />
              <select id="profile3" style="width:20%;margin-left:2%;" v-on:change="handleProfile($event)">
                      <option selected="true" disabled="true">Profile Attribute</option>
                      <option value="%%emailaddr%%">Email Address</option>
                      <option value="%%FirstName%%">FirstName</option>
              </select>     
            </div>
            Title <input type="text" id="title" style="width:95%;" placeholder="Enter text describing the link" :value="content.title" /><br/>
            Tracking Alias <input type="text" id="trackalias" style="width:95%;" placeholder="Enter tracking alias" :value="content.trackingalias" /><br/>
            <input type="checkbox" id="ctl" :checked="content.conversiontrakinglink"/> Conversion Traking link <br/><br/>
          </div>

          <div class="model-footer">
             <button class="alignbtn"  @click="handleCloseLinkModel">Cancel</button> &nbsp;&nbsp;
             <button class="alignbtn" id="savelink" v-on:click="saveLinkData($event);" disabled>Save</button>
          </div>

        </div>
   </div>
   
  </div>
</template>

<script>
import Spinner from "./Spinner";
import Modal from "./Modal";
import Prompt from "./Prompt";
import SDK from "blocksdk";
import Vue from 'vue';

import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
Vue.use(VueTabs)
const sdk = new SDK();
const DEFAULT_WIDTH = "600px";

export default {
  name: "IntelligenceBankContainer",
  components: {Prompt, Modal, Spinner},
  data() {
    return {

      options: [
        {text:'None', value: 'none'},
        { text: 'Solid', value: 'solid' },
        { text: 'Dashed', value: 'dashed' },
        { text: 'Ridge', value: 'ridge' }
      ],
      content: {
        _id: '', // id of content from IB
        src: '',
        scale: true,
        width: DEFAULT_WIDTH,
        height:'',
        fileHash: '',
        type: '', // type of file like "image/jpeg", "image/gif"
        name: '',
        description:'',
        alt:'',
        thumbnail: '',
        align:'center',
        url:'',
        borderwidtht:'0',
        borderwidthl:'0',
        borderwidthr:'0',
        borderwidthb:'0',
        bordercolor:'#000000',
        borderstyle:'none',
        imagepaddingt:'0',
        imagepaddingr:'0',
        imagepaddingb:'0',
        imagepaddingl:'0',
        linkurl:'',
        emailaddress:'',
        subject:'',
        title:'',
        trackingalias:'',
        conversiontrakinglink:false,
        linkvalue:'',
        containerbackgroundcolor:'none',
        containerborderstyle:'none',
        containerbordercolor:'#000000',
        containerborderwidtht:'0',
        containerborderwidthl:'0',
        containerborderwidthr:'0',
        containerborderwidthb:'0',
        containerblockpaddingt:'0',
        containerblockpaddingr:'0',
        containerblockpaddingb:'0',
        containerblockpaddingl:'0',
        containerblockmargint:'0',
        containerblockmarginr:'0',
        containerblockmarginb:'0',
        containerblockmarginl:'0',
        info:'',
        aspectRatio:''
      },
      onInputDelayTimeout: '',
      isSpinner: false,
      isModal: false,
      isLinkModel:false,
      isError: false,
      IsStaging:false,
      errorMessage: 'Something went wrong.',
      textforenv:'Switch to Staging'
    }
  },
  methods: {
    handleInput() {
      const DELAY = 500;
      window.clearTimeout(this.onInputDelayTimeout);

      this.onInputDelayTimeout = setTimeout(() => {
        this.insertContent();
      }, DELAY);
    },
    postMessageHandler(event) {
      try {
        let iframeUrl = new URL(this.iframeURL);
        if (event.origin !== iframeUrl.origin) return;
        let response = JSON.parse(event.data);
        
        if (response && response.action) {
          switch (response.action) {
            case 'resource_link':
              this.handlePublicLink(response);
              break;
            case 'resource_download':
              this.handleDownload(response);
              break;
          }
        }
      } catch (e) {
        this.handleError(e);
      }
    },

    handleSliderInput(e){
      var tempwidth = e;
      this.content.width = tempwidth;   
      this.handleInput();
    },
    roundDecimal(value, decimalplaces) {
      // Reference rounding decimals in javascript = https://www.jacklmoore.com/notes/rounding-in-javascript/
      return Number(Math.round(value + "e" + decimalplaces) + "e-" + decimalplaces);
    },
    roundDecimalBy2(value) {
      return this.roundDecimal(value, 2);
    },
    calculateHeight(){
      if (this.content.width.includes('px')) {
        this.content.height = this.roundDecimalBy2(parseInt(this.content.width) / this.content.aspectRatio) + 'px';
      }
    },
    calculateWidth() {
      if (this.content.height.includes('px')) {
        this.content.width = this.roundDecimalBy2(parseInt(this.content.height) * this.content.aspectRatio) + 'px';
      }
    },
    handleWidthInput(e) {
      if (isNaN(e.target.value) || !e.target.value) {
        this.content.width = e.target.value;
      } else {
        this.content.width = +e.target.value + 'px';
      }

      this.calculateHeight();

      this.handleInput();
    },
    handleHeightInput(e) {
      if (isNaN(e.target.value) || !e.target.value) {
        this.content.height = e.target.value;
      } else {
        this.content.height = +e.target.value + 'px';
      }

      this.calculateWidth();

      this.handleInput();
    },
    handleAlignment(e){
      this.content.align = e.target.value;

      let element = document.getElementById(e.target.id);
      element.classList.add('alignbtnselected');

      if(e.target.id === 'centerbtn'){
        let element = document.getElementById('leftbtn');
        element.classList.remove('alignbtnselected');
        let element1 = document.getElementById('rightbtn');
        element1.classList.remove('alignbtnselected');
      }
      
      if(e.target.id === 'leftbtn'){
        let element = document.getElementById('centerbtn');
        element.classList.remove('alignbtnselected');
        let element1 = document.getElementById('rightbtn');
        element1.classList.remove('alignbtnselected');
      }

      if(e.target.id === 'rightbtn'){
        let element = document.getElementById('centerbtn');
        element.classList.remove('alignbtnselected');
        let element1 = document.getElementById('leftbtn');
        element1.classList.remove('alignbtnselected');
      }

      this.handleInput();
    },
    handleBorderStyle(e){
      this.content.borderstyle = e.target.options[e.target.options.selectedIndex].value;
      this.handleInput();
    }, 
    handleBorderColor(e){
      this.content.bordercolor = e.target.value;
      this.handleInput();
    },
    handleBorderWidth(e){
      if(e.target.name=='btop'){
        this.content.borderwidtht = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bleft'){
        this.content.borderwidthl = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bright'){
       this.content.borderwidthr = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bbottom'){
        this.content.borderwidthb = e.target.value==''?'0': e.target.value;
      }
      this.handleInput();
    },
    handleImagePadding(e){
      if(e.target.name=='ptop'){
        this.content.imagepaddingt = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pleft'){
        this.content.imagepaddingl = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pright'){
       this.content.imagepaddingr = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pbottom'){
        this.content.imagepaddingb = e.target.value==''?'0': e.target.value;
      }
      this.handleInput();
    },

    handleScaleToFit(e){
      if(e!=undefined){
        this.content.scale = e.target.checked;
      }
      if(this.content.scale == true){
        document.getElementById('imgheight').setAttribute("Disabled", "disabled");
        document.getElementById('imgwidth').setAttribute("Disabled", "disabled");
        this.content.width = '';
        this.content.height = '';
      }else{
        document.getElementById('imgheight').removeAttribute("Disabled");
        document.getElementById('imgwidth').removeAttribute("Disabled");
        this.content.width = DEFAULT_WIDTH;
        this.calculateHeight();
      }

      if(this.content.linkurl!='' || this.content.emailaddress!=''){
        document.getElementById('link').style.display = "none";
        document.getElementById('removelinkblock').style.display = 'block';
      }else{
        document.getElementById('link').style.display = "block";
      }

      if(this.content.align === 'center'){
        let element = document.getElementById('centerbtn');
        element.classList.add('alignbtnselected');
       }
      if(this.content.align === 'left'){
        let element = document.getElementById('leftbtn');
        element.classList.add('alignbtnselected');
      }
      if(this.content.align === 'right'){
        let element = document.getElementById('rightbtn');
        element.classList.add('alignbtnselected');
      }

      this.handleInput();
    },
    
    addLink(e){
      let selectedVal = e.target.options[e.target.options.selectedIndex].value;
      if(selectedVal == 'email'){
        document.getElementById('linkfield').style.display = "none";
        document.getElementById('emailfields').style.display = "block";
        
        if(document.getElementById('emailid').value == ''){
           document.getElementById('savelink').setAttribute("disabled", "");
        }
      }else{
        document.getElementById('linkfield').style.display = "block";
        document.getElementById('emailfields').style.display = "none";
        
        if(document.getElementById('linkurl').value == ''){
           document.getElementById('savelink').setAttribute("disabled", "");
        }
      }
      
    },
    saveLinkData(){
      
      this.content.subject = document.getElementById('sub').value;
      this.content.title = document.getElementById('title').value;
      this.content.trackalias = document.getElementById('trackalias').value;
      this.content.conversiontrakinglink = document.getElementById('ctl').checked;
      
      if(document.getElementById('linkto').value == 'website'){
        
        if(document.getElementById('linkurl').value !='' && document.getElementById('linkurl').value!=undefined && document.getElementById('linkurl').value!=null){
          this.content.linkurl = document.getElementById('linkurl').value;
          this.content.emailaddress = '';
          this.content.linkvalue = 'http://'+ document.getElementById('linkurl').value;
          document.getElementById('link').style.display = "none";
          document.getElementById('removelinkblock').style.display = 'block';
        }else{
          document.getElementById('link').style.display = "block";
        }
      }else if(document.getElementById('linkto').value == 'securewebsite'){
 
        if(document.getElementById('linkurl').value !='' && document.getElementById('linkurl').value!=undefined && document.getElementById('linkurl').value!=null){
          this.content.linkurl = document.getElementById('linkurl').value;
          this.content.emailaddress = '';
          this.content.linkvalue = 'https://'+ document.getElementById('linkurl').value;
          document.getElementById('link').style.display = "none";
          document.getElementById('removelinkblock').style.display = 'block';
         }else{
          document.getElementById('link').style.display = 'block';
        }
      }else if(document.getElementById('linkto').value == 'email'){
        if(document.getElementById('emailid').value !='' && document.getElementById('emailid').value!=undefined && document.getElementById('emailid').value!=null){
          this.content.linkurl = '';
          this.content.emailaddress = document.getElementById('emailid').value;
          this.content.linkvalue = 'mailto: '+ document.getElementById('emailid').value+'?subject='+document.getElementById('sub').value;
          document.getElementById('link').style.display = "none";
          document.getElementById('removelinkblock').style.display = 'block';
        }else{
          document.getElementById('link').style.display = "block";
        }
        
      }

      this.handleInput();
      var model = document.getElementById('myModal');
      model.style.display = 'none';
    },
    handleLink(){
      var model = document.getElementById('myModal');
      model.style.display = 'block';
    },
    handleCloseLinkModel(){
      var model = document.getElementById('myModal');
      model.style.display = 'none';
    },
    handleRemoveLink(){
      this.content.linkvalue = '';
      this.content.subject = '';
      this.content.title = '';
      this.content.trackalias = '';
      this.content.conversiontrakinglink = '';
      this.content.linkurl = '';
      this.content.emailaddress = '';
      document.getElementById('link').style.display = "block";
      document.getElementById('removelinkblock').style.display = 'none';
      document.getElementById('savelink').setAttribute("disabled", "");
      this.handleInput();
    },
    showSaveBtn(e){
      if(e!=undefined && e.target.value!='' && e.target.value!=undefined && e.target.value!=null){
        document.getElementById('savelink').removeAttribute("disabled");
      }else{  
        document.getElementById('savelink').setAttribute("disabled", "");
      }
    },
    handleDeleteContent(){
      if(this.content){
        let htmlContent='';
        sdk.setContent(htmlContent);
        sdk.setData('');
        this.isModal = false;
      }
      },
    handleProfile(e){
      
      if(e.target.id == 'profile1'){
        let selectedVal = e.target.options[e.target.options.selectedIndex].value;
        document.getElementById('linkurl').value += selectedVal; 
      }else if(e.target.id == 'profile2'){
        let selectedVal = e.target.options[e.target.options.selectedIndex].value;
        document.getElementById('emailid').value += selectedVal;
      }else if(e.target.id == 'profile3'){
        let selectedVal = e.target.options[e.target.options.selectedIndex].value;
        document.getElementById('sub').value += selectedVal;
      }
    },
    handlebackColor(e){
     if(e!=undefined && e.target.value!=''){
        this.content.containerbackgroundcolor = e.target.value;
      }else{
        this.content.containerbackgroundcolor = 'none';
      }
      this.handleInput();
    },

    handleContainerBorderStyle(e){
      this.content.containerborderstyle = e.target.options[e.target.options.selectedIndex].value;
      this.handleInput();
      }, 
    handleContainerBorderColor(e){
      this.content.containerbordercolor = e.target.value;
      this.handleInput();
    },
    handleContainerBorderWidth(e){
      if(e.target.name=='bctop'){
        this.content.containerborderwidtht = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bcleft'){
        this.content.containerborderwidthl = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bcright'){
       this.content.containerborderwidthr = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='bcbottom'){
        this.content.containerborderwidthb = e.target.value==''?'0': e.target.value;
      }
      this.handleInput();
    },
    handleContainerPadding(e){
      if(e.target.name=='pctop'){
        this.content.containerblockpaddingt = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pcleft'){
        this.content.containerblockpaddingl = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pcright'){
       this.content.containerblockpaddingr = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='pcbottom'){
        this.content.containerblockpaddingb = e.target.value==''?'0': e.target.value;
      }
      this.handleInput();
    },

    handleContainerMargin(e){
      if(e.target.name=='mtop'){
        this.content.containerblockmargint = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='mleft'){
        this.content.containerblockmarginl = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='mright'){
       this.content.containerblockmarginr = e.target.value==''?'0': e.target.value;
      }else if(e.target.name=='mbottom'){
        this.content.containerblockmarginb = e.target.value==''?'0': e.target.value;
      }
      this.handleInput();
    },

    insertContent() {
      try {
        if (!this.content.src || !this.content.type) return null;
        let htmlCoreContent = ``;

        if (this.content.type.startsWith('audio')) {

          if(this.content.scale){
            htmlCoreContent = `<video class="ib-content"
                                    controls
                                    style="width:100%;height:auto;
                                    display: block;
                                    padding-top: ${this.content.imagepaddingt}px;
                                    padding-left: ${this.content.imagepaddingl}px;
                                    padding-right: ${this.content.imagepaddingr}px;
                                    padding-bottom: ${this.content.imagepaddingb}px;
                                    text-align: ${this.content.align};
                                    border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    ">
                                    <source src=${this.content.src} type=${this.content.type}>
                                    <a href=${this.content.src}>${this.content.name}</a>
                              </video>`;

          }else{
                                    htmlCoreContent = `<video class="ib-content"
                                    controls
                                    style="display: block;
                                    padding-top: ${this.content.imagepaddingt}px;
                                    padding-left: ${this.content.imagepaddingl}px;
                                    padding-right: ${this.content.imagepaddingr}px;
                                    padding-bottom: ${this.content.imagepaddingb}px;
                                    text-align: ${this.content.align};
                                    border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor};  
                                   
                                    height: ${this.content.height};
                                    width: ${this.content.width};">
                                    <source src=${this.content.src} type=${this.content.type}>
                                    <a href=${this.content.src}>${this.content.name}</a>
                              </video>`;
          }
        } else if (this.content.type.startsWith('image')) {
          if(this.content.scale){
            htmlCoreContent = `<img src=${this.content.src}
                                    alt=${this.content.alt}
                                    class="ib-content"
                                    id="${this.content._id}"
                                    style="width:100%;height:auto;
                                    display: block;
                                    padding-top: ${this.content.imagepaddingt}px;
                                    padding-left: ${this.content.imagepaddingl}px;
                                    padding-right: ${this.content.imagepaddingr}px;
                                    padding-bottom: ${this.content.imagepaddingb}px;
                                    text-align: ${this.content.align};
                                    border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    ">`;
          }else{
              htmlCoreContent =
              `<img src=${this.content.src}
                    alt=${this.content.alt}
                    class="ib-content"
                    id="${this.content._id}"
                    loading="lazy"
                    style="display: block;
                            padding-top: ${this.content.imagepaddingt}px;
                            padding-left: ${this.content.imagepaddingl}px;
                            padding-right: ${this.content.imagepaddingr}px;
                            padding-bottom: ${this.content.imagepaddingb}px;
                            text-align: ${this.content.align};
                            border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                            border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                            border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                            border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                            border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor};  
                            height: ${this.content.height};
                            width: ${this.content.width};
                            ">`;
          }

        } else if (this.content.type.startsWith('video')) {

          if(this.content.scale){
            htmlCoreContent = `<video class="ib-content"
                                    controls
                                    poster = ${this.content.thumbnail}
                                    style="width:100%;height:auto;
                                    display: block;
                                    padding-top: ${this.content.imagepaddingt}px;
                                    padding-left: ${this.content.imagepaddingl}px;
                                    padding-right: ${this.content.imagepaddingr}px;
                                    padding-bottom: ${this.content.imagepaddingb}px;
                                    border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor};">
                                    <source src=${this.content.src}>
                                    <a href=${this.content.src}>${this.content.name}</a>
                              </video>`;
          }else{

                htmlCoreContent = `<video class="ib-content"
                                    controls
                                    poster = ${this.content.thumbnail}
                                    style="display: block;
                                    padding-top: ${this.content.imagepaddingt}px;
                                    padding-left: ${this.content.imagepaddingl}px;
                                    padding-right: ${this.content.imagepaddingr}px;
                                    padding-bottom: ${this.content.imagepaddingb}px;
                                    border: 1px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-top: ${this.content.borderwidtht}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    border-right: ${this.content.borderwidthr}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-bottom: ${this.content.borderwidthb}px ${this.content.borderstyle} ${this.content.bordercolor}; 
                                    border-left: ${this.content.borderwidthl}px ${this.content.borderstyle} ${this.content.bordercolor};
                                    width: ${this.content.width};
                                    height: ${this.content.height};">
                                    <source src=${this.content.src}>
                                    <a href=${this.content.src}>${this.content.name}</a>
                              </video>`;
          }
        } else {
          throw {message: 'This content type is not supported for insertion'};
        }


        if(this.content.linkvalue!='' && this.content.linkvalue!=null){
            let temp =`<a href="${this.content.linkvalue}">
                              ${htmlCoreContent}
                            </a>`;
            htmlCoreContent = temp;
            }

        let htmlContent =
            `<table id="imgTable" width="100%" cellspacing="0" cellpadding="0" role="presentation"
                    style=  "background:${this.content.containerbackgroundcolor};
                            border: 1px ${this.content.containerborderstyle} ${this.content.containerbordercolor};
                            border-top: ${this.content.containerborderwidtht}px ${this.content.containerborderstyle} ${this.content.containerbordercolor};
                            border-right: ${this.content.containerborderwidthr}px ${this.content.containerborderstyle} ${this.content.containerbordercolor}; 
                            border-bottom: ${this.content.containerborderwidthb}px ${this.content.containerborderstyle} ${this.content.containerbordercolor}; 
                            border-left: ${this.content.containerborderwidthl}px ${this.content.containerborderstyle} ${this.content.containerbordercolor};
                            padding-top: ${this.content.containerblockpaddingt}px;
                            padding-left: ${this.content.containerblockpaddingl}px;
                            padding-right: ${this.content.containerblockpaddingr}px;
                            padding-bottom: ${this.content.containerblockpaddingb}px;
                            margin-top: ${this.content.containerblockmargint}px;
                            margin-left: ${this.content.containerblockmarginl}px;
                            margin-right: ${this.content.containerblockmarginr}px;
                            margin-bottom: ${this.content.containerblockmarginb}px;
                            ">
                <tr>
                    <td align="${this.content.align}">
                        ${htmlCoreContent}
                    </td>
                </tr>
            </table>`;

        sdk.setContent(htmlContent);
        sdk.setData(this.content);
        this.isModal = true;
      } catch (e) {
        this.handleError(e);
      }
    },
    handleError(error) {
      console.error(error);
      this.errorMessage = 'Something went wrong.';

      if (error.message) {
        this.errorMessage = error.message;
      }

      if (error.status) {
        this.errorMessage += ' HTTP error: ' + error.status;
      }

      this.isSpinner = false;
      this.isError = true;
    },
    handleCloseModal() {
      this.isModal = false;
    },
    handleCloseLinkModal(){
      this.isLinkModel = false;
    },
    hidePrompt() {
      this.isError = false;
    },
    handlePublicLink(messageData) {
      if (messageData._id) this.content._id = messageData._id;
      if (messageData.fileHash) this.content.fileHash = messageData.fileHash;
      if (messageData.type) this.content.type = messageData.type;
      if (messageData.name) this.content.name = messageData.name;
      this.content.description = messageData.description;
      if (messageData.thumbnail) this.content.thumbnail = messageData.thumbnail;
      if(messageData.url) this.content.url = messageData.url;
      
      if(messageData['preset.fileType']){
        this.content.type = 'image/'+messageData['preset.fileType'];
      }
       if (messageData.url) {
        if(this.content.type.startsWith('video')) {
          this.content.src = messageData.url.replace('/streaming/', '/original/');
        } else {
          this.content.src = messageData.url;
        }
      }

      if(messageData['preset.fileType']){
        let presetsize = String(messageData['preset.fileSize']);
        let presetsizewidth = messageData['preset.customWidth'];
        let presetsizeHeight = messageData['preset.customHeight'];
        if(presetsize!=undefined && presetsize!=null && presetsize!='' && presetsize!='custom'){
          let sizePercent='';
          if(presetsize.includes('%')){
            sizePercent = presetsize;
          }else{
            sizePercent = presetsize+'%';
          }    
          this.content.info = messageData['preset.name']+ ' ('+messageData['preset.fileType'] +', '+ sizePercent+')';
        
        }else{

          if((presetsizewidth==undefined || presetsizewidth==null || presetsizewidth=='') && (presetsizeHeight==undefined || presetsizeHeight==null || presetsizeHeight=='')){
            this.content.info = messageData['preset.name']+ ' ('+messageData['preset.fileType']+')';
          }else{
            let sizePixel = presetsizewidth +'x'+ presetsizeHeight+' px';
            this.content.info = messageData['preset.name']+ ' ('+messageData['preset.fileType'] +', '+ sizePixel+')';
          }
          
        }


      }else{
        let sizeMB = messageData.filesize/1000000;
        sizeMB = sizeMB.toFixed(1)+' MB';
        let sizePixel = messageData.width +'x'+ messageData.height+' px';
        this.content.info = 'Original ('+messageData.filetype +', '+ sizeMB +', '+ sizePixel+')';
        this.content.aspectRatio = +messageData.width / +messageData.height;
      }

      sdk.getData((data) => {
        try{
        this.content.width = data.width ? data.width : this.content.width;
        if(this.content.description){
            this.content.alt = this.content.description;
        }else{
          this.content.alt = this.content.name;
        }
        if (this.haveSameData(data, this.content)) {
          this.isModal = true;
        } else {

           if(this.content.type.startsWith('audio')){
            this.content.height = '50px';
          }
          this.insertContent();
        }
      }catch(e){
       this.handleError(e);
      }
      });
      setTimeout(this.handleScaleToFit, 100);
    },
    haveSameData(obj1, obj2) {
      const obj1Length = Object.keys(obj1).length;
      const obj2Length = Object.keys(obj2).length;

      if (obj1Length === obj2Length) {
        return Object.keys(obj1).every(
            // eslint-disable-next-line no-prototype-builtins
            key => obj2.hasOwnProperty(key)
                && obj2[key] === obj1[key]);
      }
      return false;
    },
    handleDownload(messageData) {
      if (messageData && messageData.download_url) {
        window.location.assign(messageData.download_url);
      }
    }
  },
  mounted() {
    try {
      
      window.addEventListener('message', this.postMessageHandler);
      
      sdk.getData(data => {
        if (Object.getPrototypeOf(data) !== Object.prototype) return;
        if (Object.keys(data).length === 0) return;
        this.content = data;
        this.isModal = true;
      });
    } catch (e) {
      this.handleError(e);
    }

  setTimeout(this.handleScaleToFit, 100);
  },
  computed: {
    iframeURL() {
      let urlString = window.location.href;
      let url = new URL(urlString);
      let app = 'smc';

      if(url.searchParams.has("app")) {
        let app_param = url.searchParams.get("app");

        if(app_param === 'smc') app = 'smc';
        if(app_param === 'smc_public') app = 'smc_public';
      }

      let iframeUrlString = process.env.VUE_APP_IFRAME_URL;
      let iframeUrl = new URL(iframeUrlString);
      iframeUrl.searchParams.set('app', app);
      return iframeUrl.href;
    }
  }
}
</script>

<style scoped>
.iframe-container iframe {
  height: 100vh;
  width: 100%;
  border: 0;
}

.alignbtn {
  width: 33%;
  background: white;
  border: 1px solid;
}

.alignbtn:hover {
  background-color: #e7e7e7;
  }
.alignbtnselected{
  background-color: #e7e7e7;
}
.borderInput{
  text-align: center;
  width: 19px;
  border: none;
  outline:none;
  background-color: #e7e7e7;
}


.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9001; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  font-size: 12px;
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  margin-bottom: 5%;
}
.model-header{
  margin: auto;
  padding: 20px;
  background-color: #fefefe;
  text-align:center;
  width: 80%;
}
.model-footer{
  margin: auto;
  padding: 20px;
  background-color: #fefefe;
  border-top:2px solid #d8dde6;
  text-align:right;
  width: 100%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

</style>